export const QA_NAME_LABEL_SELECT_DROPDOWN_LIST_FOOTER_ADD_NEW_LABEL_BTN =
  'addNewLabel'
